import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class AppointmentWebApi extends WebApi {
    async chooseAppointmentKind(kind, id) {
        const { data } = await axios.put(`${this.urlPrefix}/account_onboarding/accounts/${id}`, {
            account: kind,
        });
        return data.account;
    }
    async chooseOrganizationType(type, account_id) {
        const { data } = await axios.put(`${this.urlPrefix}/account_onboarding/accounts/${account_id}/set_organization_type`, {
            account: {
                organization_type: type,
            },
        });
        return data.account;
    }
    async sendInterventionData(appointment) {
        return axios.post(`${this.urlPrefix}/appointments`, { appointment });
    }
    async updateAppointmentData(appointment, id) {
        const { data } = await axios.put(`${this.urlPrefix}/appointments/${id}`, { appointment });
        return data.appointment;
    }
    async refreshAppointmentData(appointment) {
        return axios.post(`${this.urlPrefix}/appointments/refresh`, { appointment });
    }
    async getCompanyAppointmentsDates(payload) {
        const { company_id, from, to } = payload;
        return axios.get(`${this.urlPrefix}/appointments/fetch_dates`, {
            params: {
                company_id,
                from,
                to,
            },
        });
    }
    async getWorkerAppointmentsDates(payload) {
        const { user_id, from, to } = payload;
        return axios.get(`${this.urlPrefix}/appointments/fetch_dates`, {
            params: {
                user_id,
                from,
                to,
            },
        });
    }
    async getAppointmentsData(payload) {
        const { company_id, from, to } = payload;
        const urlParams = `?pagination[per_page]=100`;
        return axios.get(`${this.urlPrefix}/appointments${urlParams}`, {
            params: {
                company_id,
                from,
                to,
            },
        });
    }
    async getBranchAppointmentsData(payload) {
        const { from, to } = payload;
        const url = updateUrlGetParams(`${this.urlPrefix}/appointments`, {
            'pagination[per_page]': 100,
            'branch_id': payload.branch_id,
            'from': from,
            'to': to,
        });
        const { data } = await axios.get(url);
        return data.appointments;
    }
    async getHubAppointmentsData(payload) {
        const { from, to, page } = payload;
        const url = updateUrlGetParams(`${this.urlPrefix}/appointments`, {
            'pagination[per_page]': 100,
            'pagination[page]': page,
            'hub_id': payload.hub_id,
            'from': from,
            'to': to,
        });
        const { data } = await axios.get(url);
        return data;
    }
    async getServicePointAppointmentsData(payload) {
        const { from, to, page } = payload;
        const url = updateUrlGetParams(`${this.urlPrefix}/service_point_appointments`, {
            'pagination[per_page]': 100,
            'pagination[page]': page,
            'sp_id': payload.sp_id,
            'from': from,
            'to': to,
        });
        const { data } = await axios.get(url);
        return data;
    }
    async getUserAppointmentsData(payload) {
        const { from, to, page } = payload;
        const url = updateUrlGetParams(`${this.urlPrefix}/appointments`, {
            'pagination[per_page]': 100,
            'pagination[page]': page,
            'user_id': payload.user_id,
            'from': from,
            'to': to,
        });
        const { data } = await axios.get(url);
        return data;
    }
    async getCompanyAppointmentsData(payload) {
        const { from, to } = payload;
        const url = updateUrlGetParams(`${this.urlPrefix}/appointments`, {
            'pagination[per_page]': 100,
            'company_id': payload.company_id,
            'from': from,
            'to': to,
        });
        const { data } = await axios.get(url);
        return data.appointments;
    }
    async getInterventionCancelData(appointment) {
        const payload = `${appointment.app_type.toLowerCase()}_${appointment.reference}`;
        const { data } = await axios.get(`${this.urlPrefix}/appointments/${payload}/fetch`);
        return data;
    }
    async getSocietyData() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/company_titles`);
        return data;
    }
    async getDirectBookingRoomsData(id) {
        const url = updateUrlGetParams(`${this.urlPrefix}/components/direct_booking`, {
            'user_id': id,
        });
        const { data } = await axios.get(url);
        return data;
    }
    async getAppointmentsCategories({ page, per_page = 31, opportunity, caseValue }) {
        const urlPostfix = opportunity || caseValue ? `appointment_categories_matmut` : `appointment_categories`;
        const url = updateUrlGetParams(`${this.urlPrefix}/front_helpers/${urlPostfix}`, {
            'pagination[per_page]': per_page,
            'pagination[page]': page,
            ...(opportunity && { opportunity }),
            ...(caseValue && { case: caseValue }),
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    async getAdvisorAppointmentsCategories({ page, per_page = 31, user_id }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/front_helpers/advisors_appointment_categories`, {
            'pagination[per_page]': per_page,
            'pagination[page]': page,
            user_id,
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    async getSocietyPaginationData(payload) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        const { data } = await axios.get(`${this.urlPrefix}/companies${urlParams}`);
        return data;
    }
    async getSocietyDataBySearch(payload, searchValue) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const urlParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        const { data } = await axios.get(`${this.urlPrefix}/companies?search=${searchValue}${urlParams}`);
        return data;
    }
    async createCompany(company) {
        return axios.post(`${this.urlPrefix}/companies`, { company });
    }
    async onSiteAppointments(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/on_site_appointments`, { appointment });
        return data.appointment;
    }
    async onSiteInBranchAppointments(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/on_site_in_branch_appointments`, { appointment });
        return data.appointment;
    }
    async getAvailabilitiesByOnPhone(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bph_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByOnlineVideo(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bov_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByBranchFaceToFacePublic(payload, isOsAvailabilities) {
        const endpoint = isOsAvailabilities ? 'apnt_bpb_os_availabilities' : 'apnt_bpb_availabilities';
        const url = updateUrlGetParams(`${this.urlPrefix}/${endpoint}`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesInServicePoint(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/service_point_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesInServicePointByPhone(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/service_point_by_phone_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByBranchPhonePublic(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bppb_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByBranchVideoPublic(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bvpb_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByBranchClientVideoPrivate(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bcvp_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByBranchFaceToFacePrivate(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bpr_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByBranchPhonePrivate(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bppr_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesByBranchVideoPrivate(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/apnt_bvpr_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesOnSite(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/on_site_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async getAvailabilitiesOnSiteInBranch(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/on_site_in_branch_availabilities`, payload);
        const { data } = await axios.get(url);
        return data;
    }
    async deleteCompany(id) {
        return axios.delete(`${this.urlPrefix}/companies/${id}`);
    }
    async getSocietyItemData(id) {
        const { data } = await axios.get(`${this.urlPrefix}/companies/${id}`);
        return data;
    }
    async changeCompanyData(company, companyId) {
        return axios.put(`${this.urlPrefix}/companies/${companyId}`, { company });
    }
    async bookAppointment({ dt_start, dt_end, company_id, technician_id }, id) {
        return axios.put(`${this.urlPrefix}/appointments/${id}/book`, {
            'appointment': {
                dt_start,
                dt_end,
                company_id,
                technician_id,
            },
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
    async changeAppointmentTime(payload, id) {
        const { data } = await axios.put(`${this.urlPrefix}/appointments/${id}/update_dates`, {
            'appointment': payload,
        });
        return data.appointment;
    }
    async cancelAppointment(appointment, appointmentId) {
        return axios.put(`${this.urlPrefix}/appointments/${appointmentId}/cancel`, { appointment });
    }
    async getAppointmentsBySearch(payload) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/searches/appointments`, payload));
        return data;
    }
    async getAppointmentsByParams(payload) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/searches/appointments`, payload));
        return data;
    }
    async getAppointment(id) {
        const { data } = await axios.get(`${this.urlPrefix}/appointments/${id}`);
        return data;
    }
    async getAdvisorTechLastAutocomplete(searchValue) {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/last_name_autocomplete?text=${searchValue}`);
        return data;
    }
    async getBranchTitlesAutocomplete(type, searchValue) {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/${type}_titles_autocomplete?text=${searchValue}`);
        return data;
    }
    async getBranchAddresses(post_code, branch_external_id = null) {
        const url = updateUrlGetParams(`${this.urlPrefix}/front_helpers/branch_addresses`, { post_code, branch_external_id });
        const { data } = await axios.get(url);
        return data.branch_addresses;
    }
    async getBranchAddressesVideo(post_code, branch_external_id = null) {
        const url = updateUrlGetParams(`${this.urlPrefix}/front_helpers/branch_addresses_with_video_room`, { post_code, branch_external_id });
        // temp mock
        // eslint-disable-next-line max-len
        // const { branch_addresses } = { 'branch_addresses': [{ 'id': '63faaaa8-7ece-4797-b7d1-873c976c257b', 'name': 'paris_01 (t tomasz)', 'address': '9 Rue Bergère, 75009 Paris', 'external_id': null, 'branch_video_rooms': [{ 'id': '4c1bb157-d9c0-4be6-8140-26418ce97418', 'name': 'Room1', 'address': null, 'external_id': null }, { 'id': '66f3742c-7c8b-44d5-b6b6-2950422188d7', 'name': 'Awesome Room Name', 'address': null, 'external_id': '9108' }] }, { 'id': '38dea927-b3ce-42bf-95d6-8d6a723f3dfa', 'name': 'tb_branch (test tine)', 'address': '321 Rue Lecourbe, 75015 Paris, France', 'external_id': null, 'branch_video_rooms': [{ 'id': 'b6570d04-c231-4b0e-91bb-a410218dae65', 'name': 'R1', 'address': null, 'external_id': null }, { 'id': '109100f0-a68c-4d70-b2cc-1ee5a55e17df', 'name': 'R2', 'address': null, 'external_id': null }] }, { 'id': 'acfd1f9f-075a-44bb-b028-0dce5bfa4076', 'name': 't_eugeny_1', 'address': 'Rue Marx Dormoy, 75018 Paris, France', 'external_id': null, 'branch_video_rooms': [{ 'id': 'a7cdbd66-2600-4bb3-8add-daac534069ae', 'name': 'Som rume', 'address': null, 'external_id': null }] }, { 'id': 'bf590b9f-7ce4-4cb7-9c4d-18b7ef914bf0', 'name': 'test (test tine)', 'address': '66 Avenue d\'Ivry, 75013 Paris, France', 'external_id': '9108', 'branch_video_rooms': [{ 'id': '35f251d3-b188-4e65-8427-44c943707af0', 'name': 'AddRoom', 'address': null, 'external_id': null }] }], 'meta': { 'current_page': 1, 'next_page': null, 'prev_page': null, 'total_count': 4, 'total_pages': 1 }, 'code': 0, 'errors': [] };
        const { data } = await axios.get(url);
        return data.branch_addresses;
    }
    async sendAddressForGeolocation(geolocation) {
        return axios.post(`${this.urlPrefix}/geolocations`, { geolocation });
    }
    async getClientDetails(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/clients/fetch`, payload);
        const { data } = await axios.get(url);
        return data.client;
    }
    async getClientDetailsByEmail(email) {
        const url = updateUrlGetParams(`${this.urlPrefix}/clients`, { email });
        const { data } = await axios.get(url);
        return data.clients && data.clients.length ? data.clients[0] : null;
    }
    async getClientDetailsByPhone(phone_number) {
        const url = updateUrlGetParams(`${this.urlPrefix}/clients`, { phone_number });
        const { data } = await axios.get(url);
        return data.clients && data.clients.length ? data.clients[0] : null;
    }
    async getClientDetailsByPhoneFilterByID(phone_number) {
        const url = updateUrlGetParams(`${this.urlPrefix}/clients`, { phone_number });
        const { data } = await axios.get(url);
        return data.clients && data.clients.length ? data.clients : [];
    }
    async getClientDetailsByEmailFilterByID(email) {
        const url = updateUrlGetParams(`${this.urlPrefix}/clients`, { email });
        const { data } = await axios.get(url);
        return data.clients && data.clients.length ? data.clients : [];
    }
    async bookAppointmentManually(payload) {
        const { data } = await axios.post(`${this.urlPrefix}/appointments`, {
            'appointment': payload,
        });
        return data.appointment;
    }
    async getComponentsUrlBuilder(user_id) {
        const url = updateUrlGetParams(`${this.urlPrefix}/components/url_builder`, { user_id });
        const { data } = await axios.get(url);
        return data;
    }
    async getDriveInformation(params) {
        const url = updateUrlGetParams(`${this.urlPrefix}/components/drive`, params);
        const { data } = await axios.get(url);
        return data;
    }
    async updateDriveInformation(payload) {
        const { data } = await axios.post(`${this.urlPrefix}/drives`, payload);
        return data;
    }
    async getAdvisorUrlsBuilder(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/advisor_urls`, {
            'advisor_id': payload.advisor_id,
            'kind': payload.kind,
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
            ...(payload.skill_id && { skill_id: payload.skill_id }),
            ...(payload.ac_kind && { ac_kind: payload.ac_kind }),
            ...(payload.ac_title && { ac_title: payload.ac_title }),
            ...(payload.sub_account_id && { sub_account_id: payload.sub_account_id }),
        });
        const { data } = await axios.get(url);
        return data;
    }
    async getAdvisorUrlsBuilderSelectorsData(payload) {
        const url = updateUrlGetParams(`${this.urlPrefix}/components/advisor_url_selectors`, {
            'advisor_id': payload.advisor_id,
        });
        const { data } = await axios.get(url);
        return data;
    }
    async createAdvisorUrl(postUrlBuilder) {
        const { title, id, user_id, sub_account_id } = postUrlBuilder;
        const { data } = await axios.post(`${this.urlPrefix}/advisor_urls`, {
            advisor_url: {
                advisor_id: user_id,
                appointment_category_id: id,
                skill_name: title,
                sub_account_id,
            },
        });
        return data;
    }
    async createUrlWithBuilder(postUrlBuilder) {
        const { title, id, user_id } = postUrlBuilder;
        const url = updateUrlGetParams(`${this.urlPrefix}/url_builders`, { skill_name: title, appointment_category_id: id, user_id });
        const { data } = await axios.post(url);
        return data;
    }
    async deleteAdvisorUrlBuilder(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/advisor_urls/${id}`);
        return data;
    }
    async fetchSkillNames() {
        const { data } = await axios.get(`${this.urlPrefix}/front_helpers/skill_names`);
        return data;
    }
    async fetchExporters(filters) {
        const { data } = await axios.post(`${this.urlPrefix}/exporters`, {
            exporter: {
                filters,
            },
        });
        return data;
    }
    async updateAppointmentFeedback(appointmentId, fulfilled) {
        const { data } = await axios.put(`${this.urlPrefix}/appointments/${appointmentId}/feedback`, {
            appointment: {
                fulfilled,
            },
        });
        return data.appointment || data;
    }
}
const appointmentApi = new AppointmentWebApi();
export { appointmentApi as AppointmentWebApi, };
